import { render, staticRenderFns } from "./FactsheetParticipation.vue?vue&type=template&id=3b1c2a92"
import script from "./FactsheetParticipation.vue?vue&type=script&lang=js"
export * from "./FactsheetParticipation.vue?vue&type=script&lang=js"
import style0 from "./FactsheetParticipation.vue?vue&type=style&index=0&id=3b1c2a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports